import React from "react";

export const Affects: React.FC = () => {
  return (
    <div id="why" className="affects-container">
      <img 
        src="img/img2.webp" 
        alt="Endocomunidad" 
        className="affects-image"
      />
      <div className="affects-text-overlay">
        <h3 className="affects-pre-title">Ser invisibles ante el sistema médico</h3>
        <h1 className="affects-title">Daña y mucho</h1>
        <h2 className="affects-subtitle">Hablar salva vidas</h2>
      </div>
    </div>
  );
};

